/**
 * 作品卡上「来自哪张卡」标签与创建人的**唯一**取法 —— 完成卡(`WorkCard`)与进行中卡
 * (`/works` 进行中节、首页 `InFlightRow`)共用。
 *
 * ★1006 演示机复测:进行中卡此前只传了名字 / 状态 / ownerName,场景标签整个没接(mapper 早已算出
 *   sceneKey),一键长图在途卡的创建人恒空 —— 同一单从「进行中」挪到完成区,卡面口径突然变了。
 */
import { sceneLabelOf } from "@/entities/scene-card/catalog";
import type { WorkItem } from "./types";

/** 标签:场景名优先 → 品类 → 线名(与完成卡封面左上角那枚同一条回落链)。 */
export function workOriginLabel(
  item: Pick<WorkItem, "sceneKey" | "categoryLabel" | "lineLabel">
): string {
  return sceneLabelOf(item.sceneKey) || item.categoryLabel || item.lineLabel;
}

/**
 * 创建人:列表 DTO 给了就用;没给但这条**就是当前登录人自己的**(`selfOwned`,如一键长图作业 ——
 * 作业列表接口按 owner 过滤,只回自己提交的)→ 当前登录人名;都没有 → null(不渲染)。
 */
export function workCreatorName(
  item: Pick<WorkItem, "ownerName" | "selfOwned">,
  selfName: string | null | undefined
): string | null {
  return item.ownerName || (item.selfOwned ? selfName || null : null);
}
